// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./themes.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Consolidated Theme Variables
 *
 * This file unifies the legacy and new theme systems into a single,
 * consistent set of CSS variables for the UI/UX fixes.
 *
 * Migration strategy:
 * 1. Keep new theme system as primary (--color-primary, --color-surface, etc.)
 * 2. Map legacy variables to new ones for backward compatibility
 * 3. Add specific variables needed for form consistency
 */

/* ===== PRIMARY THEME SYSTEM (NEW) ===== */
/* Import the complete new theme system */

/* ===== LEGACY COMPATIBILITY MAPPING ===== */
/* Map old variables to new ones for existing components */
:root {
  /* Legacy to new mapping */
  --background-color: var(--color-background);
  --text-color: var(--color-background-text);
  --link-color: var(--color-primary);
  --button-bg-color: var(--color-primary);
  --button-hover-bg-color: var(--color-accent);
}

body.dark-mode {
  /* Legacy dark mode compatibility - use data-theme="dark" instead */
  --background-color: var(--color-background);
  --text-color: var(--color-background-text);
  --link-color: var(--color-primary);
  --button-bg-color: var(--color-primary);
  --button-hover-bg-color: var(--color-accent);
}

/* ===== FORM-SPECIFIC VARIABLES ===== */
/* Enhanced variables for consistent form styling */
:root {
  /* Input field consistency */
  --input-width: 100%;
  --input-padding: 12px 16px;
  --input-border-radius: 8px;
  --input-border-width: 2px;
  --input-font-size: 16px;
  --input-font-family: inherit;
  --input-background: var(--color-surface);
  --input-border-color: var(--color-outline);
  --input-border-color-focus: var(--color-primary);
  --input-text-color: var(--color-surface-text);

  /* Input focus states */
  --input-focus-shadow: 0 0 0 3px rgba(25, 118, 210, 0.2);
  --input-transition: border-color 0.2s ease, box-shadow 0.2s ease;

  /* Button consistency */
  --button-width: 100%;
  --button-padding: 12px 24px;
  --button-border-radius: 8px;
  --button-font-size: 16px;
  --button-font-weight: 600;
  --button-background: var(--color-primary);
  --button-text-color: var(--color-primary-text);
  --button-background-hover: var(--color-accent);
  --button-text-color-hover: var(--color-accent-text);
  --button-transition: all 0.2s ease;
  --button-shadow-hover: 0 2px 4px var(--shadow-color);
  --button-transform-hover: translateY(-1px);

  /* Form layout */
  --form-gap: 20px;
  --form-gap-mobile: 16px;
  --form-field-margin: 16px;
  --form-container-max-width: 400px;
  --form-container-padding: 24px;
  --form-container-padding-mobile: 16px;

  /* Error states */
  --error-color: var(--color-error);
  --error-background: rgba(211, 47, 47, 0.1);
  --error-border: var(--color-error);
  --error-shadow: 0 0 0 3px rgba(211, 47, 47, 0.2);

  /* Loading states */
  --loading-background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);
  --loading-size: 200% 100%;

  /* Responsive breakpoints */
  --breakpoint-mobile: 768px;
  --breakpoint-tablet: 1024px;
  --breakpoint-desktop: 1200px;
}

/* Dark theme overrides for form variables */
[data-theme="dark"] {
  --input-background: var(--color-surface);
  --input-border-color: var(--color-outline);
  --input-border-color-focus: var(--color-primary);
  --input-text-color: var(--color-surface-text);
  --input-focus-shadow: 0 0 0 3px rgba(208, 188, 255, 0.2);

  --button-background: var(--color-primary);
  --button-text-color: var(--color-primary-text);
  --button-background-hover: var(--color-accent);
  --button-text-color-hover: var(--color-accent-text);

  --error-background: rgba(244, 143, 177, 0.1);
  --error-shadow: 0 0 0 3px rgba(244, 143, 177, 0.2);

  --loading-background: linear-gradient(90deg, transparent, rgba(0, 0, 0, 0.4), transparent);
}

/* ===== UTILITY CLASSES FOR FORM CONSISTENCY ===== */

/* Standard input styling */
.form-input {
  width: var(--input-width);
  padding: var(--input-padding);
  border-radius: var(--input-border-radius);
  border: var(--input-border-width) solid var(--input-border-color);
  font-size: var(--input-font-size);
  font-family: var(--input-font-family);
  background-color: var(--input-background);
  color: var(--input-text-color);
  outline: none;
  transition: var(--input-transition);
  box-sizing: border-box;
}

.form-input:focus {
  border-color: var(--input-border-color-focus);
  box-shadow: var(--input-focus-shadow);
}

.form-input:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.form-input.error {
  border-color: var(--error-border);
  background-color: var(--error-background);
  box-shadow: var(--error-shadow);
}

/* Standard button styling */
.form-button {
  width: var(--button-width);
  padding: var(--button-padding);
  border-radius: var(--button-border-radius);
  border: none;
  font-size: var(--button-font-size);
  font-weight: var(--button-font-weight);
  background-color: var(--button-background);
  color: var(--button-text-color);
  cursor: pointer;
  transition: var(--button-transition);
  box-sizing: border-box;
}

.form-button:hover:not(:disabled) {
  background-color: var(--button-background-hover);
  color: var(--button-text-color-hover);
  box-shadow: var(--button-shadow-hover);
  transform: var(--button-transform-hover);
}

.form-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

/* Form layout utilities */
.form-container {
  max-width: var(--form-container-max-width);
  margin: 0 auto;
  padding: var(--form-container-padding);
}

.form-field {
  margin-bottom: var(--form-field-margin);
}

.form-field:last-child {
  margin-bottom: 0;
}

.form-row {
  display: flex;
  gap: var(--form-gap);
  margin-bottom: var(--form-field-margin);
}

.form-row .form-field {
  flex: 1 1;
  margin-bottom: 0;
  min-width: 0; /* Prevents flex items from overflowing */
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .form-container {
    padding: var(--form-container-padding-mobile);
  }

  .form-row {
    flex-direction: column;
    gap: var(--form-gap-mobile);
  }

  .form-row .form-field {
    margin-bottom: var(--form-gap-mobile);
  }

  .form-row .form-field:last-child {
    margin-bottom: 0;
  }
}

/* Loading state */
.form-input.loading {
  background-image: var(--loading-background);
  background-size: var(--loading-size);
  animation: loading-shimmer 1.5s infinite;
}

@keyframes loading-shimmer {
  0% { background-position: -200% 0; }
  100% { background-position: 200% 0; }
}

/* Accessibility enhancements */
@media (prefers-reduced-motion: reduce) {
  .form-input,
  .form-button {
    transition: none;
  }

  .form-input.loading {
    animation: none;
  }
}

/* High contrast mode */
@media (prefers-contrast: high) {
  .form-input {
    border-width: 3px;
  }

  .form-input:focus {
    box-shadow: 0 0 0 4px var(--input-border-color-focus);
  }
}

/* Print styles */
@media print {
  .form-input,
  .form-button {
    border: 2px solid #000000;
    background: transparent;
    color: #000000;
    box-shadow: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/theme-variables.css"],"names":[],"mappings":"AAAA;;;;;;;;;;EAUE;;AAEF,2CAA2C;AAC3C,yCAAyC;;AAGzC,6CAA6C;AAC7C,0DAA0D;AAC1D;EACE,0BAA0B;EAC1B,2CAA2C;EAC3C,0CAA0C;EAC1C,kCAAkC;EAClC,uCAAuC;EACvC,4CAA4C;AAC9C;;AAEA;EACE,mEAAmE;EACnE,2CAA2C;EAC3C,0CAA0C;EAC1C,kCAAkC;EAClC,uCAAuC;EACvC,4CAA4C;AAC9C;;AAEA,wCAAwC;AACxC,mDAAmD;AACnD;EACE,4BAA4B;EAC5B,mBAAmB;EACnB,0BAA0B;EAC1B,0BAA0B;EAC1B,yBAAyB;EACzB,uBAAuB;EACvB,4BAA4B;EAC5B,wCAAwC;EACxC,0CAA0C;EAC1C,gDAAgD;EAChD,6CAA6C;;EAE7C,uBAAuB;EACvB,uDAAuD;EACvD,gEAAgE;;EAEhE,uBAAuB;EACvB,oBAAoB;EACpB,2BAA2B;EAC3B,2BAA2B;EAC3B,wBAAwB;EACxB,yBAAyB;EACzB,yCAAyC;EACzC,8CAA8C;EAC9C,8CAA8C;EAC9C,mDAAmD;EACnD,kCAAkC;EAClC,oDAAoD;EACpD,0CAA0C;;EAE1C,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;EACzB,iCAAiC;EACjC,8BAA8B;EAC9B,qCAAqC;;EAErC,iBAAiB;EACjB,iCAAiC;EACjC,0CAA0C;EAC1C,kCAAkC;EAClC,gDAAgD;;EAEhD,mBAAmB;EACnB,gGAAgG;EAChG,yBAAyB;;EAEzB,2BAA2B;EAC3B,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA,4CAA4C;AAC5C;EACE,wCAAwC;EACxC,0CAA0C;EAC1C,gDAAgD;EAChD,6CAA6C;EAC7C,wDAAwD;;EAExD,yCAAyC;EACzC,8CAA8C;EAC9C,8CAA8C;EAC9C,mDAAmD;;EAEnD,4CAA4C;EAC5C,kDAAkD;;EAElD,0FAA0F;AAC5F;;AAEA,qDAAqD;;AAErD,2BAA2B;AAC3B;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,yCAAyC;EACzC,iEAAiE;EACjE,iCAAiC;EACjC,qCAAqC;EACrC,yCAAyC;EACzC,8BAA8B;EAC9B,aAAa;EACb,mCAAmC;EACnC,sBAAsB;AACxB;;AAEA;EACE,6CAA6C;EAC7C,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,yCAAyC;EACzC,+BAA+B;AACjC;;AAEA,4BAA4B;AAC5B;EACE,0BAA0B;EAC1B,8BAA8B;EAC9B,0CAA0C;EAC1C,YAAY;EACZ,kCAAkC;EAClC,sCAAsC;EACtC,0CAA0C;EAC1C,+BAA+B;EAC/B,eAAe;EACf,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,gDAAgD;EAChD,qCAAqC;EACrC,sCAAsC;EACtC,wCAAwC;AAC1C;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA,0BAA0B;AAC1B;EACE,0CAA0C;EAC1C,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,uCAAuC;AACzC;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,YAAY,EAAE,yCAAyC;AACzD;;AAEA,2BAA2B;AAC3B;EACE;IACE,6CAA6C;EAC/C;;EAEA;IACE,sBAAsB;IACtB,2BAA2B;EAC7B;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA,kBAAkB;AAClB;EACE,2CAA2C;EAC3C,oCAAoC;EACpC,wCAAwC;AAC1C;;AAEA;EACE,KAAK,4BAA4B,EAAE;EACnC,OAAO,2BAA2B,EAAE;AACtC;;AAEA,+BAA+B;AAC/B;EACE;;IAEE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,uBAAuB;AACvB;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,qDAAqD;EACvD;AACF;;AAEA,iBAAiB;AACjB;EACE;;IAEE,yBAAyB;IACzB,uBAAuB;IACvB,cAAc;IACd,gBAAgB;EAClB;AACF","sourcesContent":["/**\n * Consolidated Theme Variables\n *\n * This file unifies the legacy and new theme systems into a single,\n * consistent set of CSS variables for the UI/UX fixes.\n *\n * Migration strategy:\n * 1. Keep new theme system as primary (--color-primary, --color-surface, etc.)\n * 2. Map legacy variables to new ones for backward compatibility\n * 3. Add specific variables needed for form consistency\n */\n\n/* ===== PRIMARY THEME SYSTEM (NEW) ===== */\n/* Import the complete new theme system */\n@import './themes.css';\n\n/* ===== LEGACY COMPATIBILITY MAPPING ===== */\n/* Map old variables to new ones for existing components */\n:root {\n  /* Legacy to new mapping */\n  --background-color: var(--color-background);\n  --text-color: var(--color-background-text);\n  --link-color: var(--color-primary);\n  --button-bg-color: var(--color-primary);\n  --button-hover-bg-color: var(--color-accent);\n}\n\nbody.dark-mode {\n  /* Legacy dark mode compatibility - use data-theme=\"dark\" instead */\n  --background-color: var(--color-background);\n  --text-color: var(--color-background-text);\n  --link-color: var(--color-primary);\n  --button-bg-color: var(--color-primary);\n  --button-hover-bg-color: var(--color-accent);\n}\n\n/* ===== FORM-SPECIFIC VARIABLES ===== */\n/* Enhanced variables for consistent form styling */\n:root {\n  /* Input field consistency */\n  --input-width: 100%;\n  --input-padding: 12px 16px;\n  --input-border-radius: 8px;\n  --input-border-width: 2px;\n  --input-font-size: 16px;\n  --input-font-family: inherit;\n  --input-background: var(--color-surface);\n  --input-border-color: var(--color-outline);\n  --input-border-color-focus: var(--color-primary);\n  --input-text-color: var(--color-surface-text);\n\n  /* Input focus states */\n  --input-focus-shadow: 0 0 0 3px rgba(25, 118, 210, 0.2);\n  --input-transition: border-color 0.2s ease, box-shadow 0.2s ease;\n\n  /* Button consistency */\n  --button-width: 100%;\n  --button-padding: 12px 24px;\n  --button-border-radius: 8px;\n  --button-font-size: 16px;\n  --button-font-weight: 600;\n  --button-background: var(--color-primary);\n  --button-text-color: var(--color-primary-text);\n  --button-background-hover: var(--color-accent);\n  --button-text-color-hover: var(--color-accent-text);\n  --button-transition: all 0.2s ease;\n  --button-shadow-hover: 0 2px 4px var(--shadow-color);\n  --button-transform-hover: translateY(-1px);\n\n  /* Form layout */\n  --form-gap: 20px;\n  --form-gap-mobile: 16px;\n  --form-field-margin: 16px;\n  --form-container-max-width: 400px;\n  --form-container-padding: 24px;\n  --form-container-padding-mobile: 16px;\n\n  /* Error states */\n  --error-color: var(--color-error);\n  --error-background: rgba(211, 47, 47, 0.1);\n  --error-border: var(--color-error);\n  --error-shadow: 0 0 0 3px rgba(211, 47, 47, 0.2);\n\n  /* Loading states */\n  --loading-background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);\n  --loading-size: 200% 100%;\n\n  /* Responsive breakpoints */\n  --breakpoint-mobile: 768px;\n  --breakpoint-tablet: 1024px;\n  --breakpoint-desktop: 1200px;\n}\n\n/* Dark theme overrides for form variables */\n[data-theme=\"dark\"] {\n  --input-background: var(--color-surface);\n  --input-border-color: var(--color-outline);\n  --input-border-color-focus: var(--color-primary);\n  --input-text-color: var(--color-surface-text);\n  --input-focus-shadow: 0 0 0 3px rgba(208, 188, 255, 0.2);\n\n  --button-background: var(--color-primary);\n  --button-text-color: var(--color-primary-text);\n  --button-background-hover: var(--color-accent);\n  --button-text-color-hover: var(--color-accent-text);\n\n  --error-background: rgba(244, 143, 177, 0.1);\n  --error-shadow: 0 0 0 3px rgba(244, 143, 177, 0.2);\n\n  --loading-background: linear-gradient(90deg, transparent, rgba(0, 0, 0, 0.4), transparent);\n}\n\n/* ===== UTILITY CLASSES FOR FORM CONSISTENCY ===== */\n\n/* Standard input styling */\n.form-input {\n  width: var(--input-width);\n  padding: var(--input-padding);\n  border-radius: var(--input-border-radius);\n  border: var(--input-border-width) solid var(--input-border-color);\n  font-size: var(--input-font-size);\n  font-family: var(--input-font-family);\n  background-color: var(--input-background);\n  color: var(--input-text-color);\n  outline: none;\n  transition: var(--input-transition);\n  box-sizing: border-box;\n}\n\n.form-input:focus {\n  border-color: var(--input-border-color-focus);\n  box-shadow: var(--input-focus-shadow);\n}\n\n.form-input:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.form-input.error {\n  border-color: var(--error-border);\n  background-color: var(--error-background);\n  box-shadow: var(--error-shadow);\n}\n\n/* Standard button styling */\n.form-button {\n  width: var(--button-width);\n  padding: var(--button-padding);\n  border-radius: var(--button-border-radius);\n  border: none;\n  font-size: var(--button-font-size);\n  font-weight: var(--button-font-weight);\n  background-color: var(--button-background);\n  color: var(--button-text-color);\n  cursor: pointer;\n  transition: var(--button-transition);\n  box-sizing: border-box;\n}\n\n.form-button:hover:not(:disabled) {\n  background-color: var(--button-background-hover);\n  color: var(--button-text-color-hover);\n  box-shadow: var(--button-shadow-hover);\n  transform: var(--button-transform-hover);\n}\n\n.form-button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n/* Form layout utilities */\n.form-container {\n  max-width: var(--form-container-max-width);\n  margin: 0 auto;\n  padding: var(--form-container-padding);\n}\n\n.form-field {\n  margin-bottom: var(--form-field-margin);\n}\n\n.form-field:last-child {\n  margin-bottom: 0;\n}\n\n.form-row {\n  display: flex;\n  gap: var(--form-gap);\n  margin-bottom: var(--form-field-margin);\n}\n\n.form-row .form-field {\n  flex: 1;\n  margin-bottom: 0;\n  min-width: 0; /* Prevents flex items from overflowing */\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .form-container {\n    padding: var(--form-container-padding-mobile);\n  }\n\n  .form-row {\n    flex-direction: column;\n    gap: var(--form-gap-mobile);\n  }\n\n  .form-row .form-field {\n    margin-bottom: var(--form-gap-mobile);\n  }\n\n  .form-row .form-field:last-child {\n    margin-bottom: 0;\n  }\n}\n\n/* Loading state */\n.form-input.loading {\n  background-image: var(--loading-background);\n  background-size: var(--loading-size);\n  animation: loading-shimmer 1.5s infinite;\n}\n\n@keyframes loading-shimmer {\n  0% { background-position: -200% 0; }\n  100% { background-position: 200% 0; }\n}\n\n/* Accessibility enhancements */\n@media (prefers-reduced-motion: reduce) {\n  .form-input,\n  .form-button {\n    transition: none;\n  }\n\n  .form-input.loading {\n    animation: none;\n  }\n}\n\n/* High contrast mode */\n@media (prefers-contrast: high) {\n  .form-input {\n    border-width: 3px;\n  }\n\n  .form-input:focus {\n    box-shadow: 0 0 0 4px var(--input-border-color-focus);\n  }\n}\n\n/* Print styles */\n@media print {\n  .form-input,\n  .form-button {\n    border: 2px solid #000000;\n    background: transparent;\n    color: #000000;\n    box-shadow: none;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
